import { AxiosInstance } from 'axios';

function extractAccessToken() {
    const relatedLocalStorageData = localStorage.getItem('edf:app-web:auth-store');

    if (relatedLocalStorageData == null) {
        return '';
    }

    const parsedData = JSON.parse(relatedLocalStorageData);
    const accessToken = parsedData?.state?.accessToken as string | undefined;

    return accessToken ?? '';
}

export function setTokenOnRequests(axios: AxiosInstance): void {
    axios.interceptors.request.use((request) => {
        const token = extractAccessToken();

        if (request.headers != null && token !== '') {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = `Bearer ${token}`;
        }

        return request;
    });
}
